module.exports = __webpack_public_path__ + "static/media/sakerhetsventil.666c5c4e.png";